import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@plecto/ui';
import { PaneButtons, PaneContent } from './PaneModal.styled';
import { PaneModal } from './PaneModal';

type ConfirmDeleteModalProps = {
    objectType: string;
    objectName: string;
    relatedItems: {
        id: string;
        name: string;
        type: string;
    }[];
    onConfirmed: () => void;
    onClose: () => void;
}

export function ConfirmDeleteModal({
	objectType, objectName, relatedItems, onConfirmed, onClose
}: ConfirmDeleteModalProps) {
	const { t } = useTranslation();

	const onConfirmedCallback = useCallback(() => {
		onClose();
		onConfirmed();
	},[onClose, onConfirmed]);

	return <PaneModal
		title={t('Delete object')}
		onClose={onClose}
		forceTop
	>
		<PaneContent>
			{/* eslint-disable-next-line max-len */}
			<p>
				{t('Are you sure you want to delete')}
				<strong> {objectName} </strong>
				{t('object? If deleted, it will be permanently lost.')}
			</p>
			<p>{objectType}: <strong>{objectName}</strong></p>
			{relatedItems && relatedItems.length ?
				<div className="table-responsive">
					<table className="table table-condensed nomargin">
						<thead>
							<tr><th>{t('The following related items will be deleted:')}</th></tr>
						</thead>
						<tbody>
							{relatedItems.map(item =>
								<tr key={item.id}><td>{`${item.type}: ${item.name}`}</td></tr>)}
						</tbody>
					</table>
				</div> : null}
			<div className="spacer"></div>
		</PaneContent>
		<PaneButtons>
			<Button label={t('Cancel')} variant={'secondary'} onClick={onClose} />
			<Button label={t('Delete')} variant={'danger'} onClick={onConfirmedCallback} />

		</PaneButtons>
	</PaneModal>;
}
